import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdInnovationInsidersOptInCacheKeys: AllRouteEndpoints[] = [];
